import { useCallback, useState } from 'react';
import { noop } from 'lodash';
import { callPostApi } from 'services/api/apiCallerProxy';
import { useCurrentValueGetter } from '../../../../hooks';
import { useConfigMatch } from '../../account-configurations';
import { FEATURE_FLAGS } from '../../account-configurations/flags/featureFlags';

const customFetch = async (url, options = {}) => {
    const response = await callPostApi(url, {}, options, true, true);
    return response;
};

export const useChatKitService = () => {
    const [chatKitContainer, setChatKitContainer] = useState(null);

    const isChatKitEnabled = useConfigMatch({ [FEATURE_FLAGS.CHAT_KIT_ENABLED]: 'true' });
    const chatKitContainerGetter = useCurrentValueGetter(isChatKitEnabled ? chatKitContainer : null);

    const reset = useCallback(() => {
        if (!isChatKitEnabled) {
            return;
        }

        if (chatKitContainer) {
            chatKitContainer.setThreadId(null);
        }
        setChatKitContainer(null);
    }, [isChatKitEnabled, chatKitContainer]);

    if (!isChatKitEnabled) {
        return {
            initialize: noop,
            reset,
            chatKitContainer: null,
            setChatKitContainer: noop,
            chatKitContainerGetter,
        };
    }

    const initialize = ({ chatKitContainer, clientTools, searchStr }) => {
        if (!chatKitContainer) {
            console.warn('ChatKit container is not available for initialization');
            return;
        }

        chatKitContainer.setOptions({
            apiURL: `/external-api/sse/chatkit${searchStr ? `?${searchStr}` : ''}`,
            mode: 'inline',
            fetch: customFetch,
            layout: 'compact',
            header: false,
            clientTools,
            composer: {
                placeholder: 'Ask a Creative Strategist',
            },
        });

        setChatKitContainer(chatKitContainer);
    };

    return {
        initialize,
        reset,
        chatKitContainer,
        setChatKitContainer,
        chatKitContainerGetter,
    };
};
